__turbopack_context__.v({
  "clearButton": "search-input-module__w5UhYq__clearButton",
  "input": "search-input-module__w5UhYq__input",
  "leftSection": "search-input-module__w5UhYq__leftSection",
  "rightSection": "search-input-module__w5UhYq__rightSection",
  "root": "search-input-module__w5UhYq__root",
  "section": "search-input-module__w5UhYq__section",
  "stretch": "search-input-module__w5UhYq__stretch",
  "wrapper": "search-input-module__w5UhYq__wrapper",
  "wrapperWithClear": "search-input-module__w5UhYq__wrapperWithClear",
  "wrapperWithoutSearchIcon": "search-input-module__w5UhYq__wrapperWithoutSearchIcon",
});
